import React from 'react';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import { Edit } from '@material-ui/icons';
import { css } from '@emotion/react';
import { OnwardButtonIcon } from '@/styles/blocks';

const HeaderBar = ({ deliveryProfileId, deliveryProfiles, onSelect, onCreate, onEdit }) => {
    return (
        <Grid
            container
            css={css`
                padding: 12px 20px 0px 20px;
                gap: 16px;
                flex-wrap: nowrap;
                align-items: center;
            `}
        >
            <Grid
                item
                css={css`
                    flex-grow: 1;
                    min-width: 0;
                `}
            >
                <TextField
                    select
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Delivery Profile"
                    value={deliveryProfileId || ''}
                    InputLabelProps={{ shrink: !!deliveryProfileId }}
                    onChange={(e) => onSelect(e.target.value)}
                >
                    {deliveryProfiles.map((option) => (
                        <MenuItem key={option.delivery_profile_id} value={option.delivery_profile_id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            {deliveryProfileId ? (
                <Grid item>
                    <OnwardButtonIcon Icon={Edit} onClick={onEdit} />
                </Grid>
            ) : null}
            <Grid item>
                <OnwardButtonIcon Icon={AddIcon} onClick={onCreate} />
            </Grid>
        </Grid>
    );
};

export default HeaderBar;
